import { Button, Grid, Group, Radio } from '@mantine/core';
import {
  IconArrowLeft,
  IconArrowRight,
  IconUserDollar,
  IconUsers,
  IconUsersGroup,
} from '@tabler/icons-react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TitleDescriptionRadio } from 'src/Components/Shared/TitleDescriptionRadio';
import { CreateAssetDtoSubTypeEnum } from 'src/Services/API/generated';

import styles from './OnboardingSelectRealEstatePlanForm.module.scss';
import { Props } from './OnboardingSelectRealEstatePlanForm.types';

const OnboardingSelectRealEstatePlanForm = ({ onPlanSelect, goToPreviousStep }: Props) => {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      {
        label: t('onboarding.realEstatePlan.family.label', 'Bien familial'),
        description: t(
          'onboarding.realEstatePlan.family.description',
          'Un bien pour une gestion en famille à plus de 2'
        ),
        icon: IconUsersGroup,
        key: CreateAssetDtoSubTypeEnum.FamilyProperty,
      },
      {
        label: t('onboarding.realEstatePlan.couple.label', 'Habitation'),
        description: t(
          'onboarding.realEstatePlan.couple.description',
          'Une résidence principale à deux'
        ),
        icon: IconUsers,
        key: CreateAssetDtoSubTypeEnum.PrimaryResidence,
      },
      {
        label: t('onboarding.realEstatePlan.renting.label', 'Location'),
        description: t(
          'onboarding.realEstatePlan.renting.description',
          'Idéal pour un bien en location'
        ),
        icon: IconUserDollar,
        key: CreateAssetDtoSubTypeEnum.RentalProperty,
      },
    ],
    [t]
  );

  const [value, setValue] = useState<CreateAssetDtoSubTypeEnum>(
    CreateAssetDtoSubTypeEnum.FamilyProperty
  );

  return (
    <div className={styles.container}>
      <p className={styles.title}>{t('onboarding.realEstatePlan.title', 'Votre usage du bien')}</p>
      <p className={styles.description}>
        {t(
          'onboarding.realEstatePlan.subTitle',
          "Choisissez votre type d'occupation en fonction de l'utilisation de votre bien et du nombre de co-gérants :"
        )}
      </p>
      <Radio.Group value={value} onChange={value => setValue(value as CreateAssetDtoSubTypeEnum)}>
        <Grid>
          {options.map(option => (
            <Grid.Col key={option.key} span={{ base: 12, sm: 6, md: 4 }}>
              <TitleDescriptionRadio
                key={option.key}
                value={option.key}
                title={option.label}
                description={option.description}
                illustrationIcon={option.icon}
              />
            </Grid.Col>
          ))}
        </Grid>
      </Radio.Group>
      <Group justify={'space-between'} className={styles.actions}>
        <Button
          leftSection={<IconArrowLeft height={18} />}
          variant={'outline'}
          onClick={() => goToPreviousStep()}
        >
          {t('onboarding.previous', 'Précédent')}
        </Button>
        <Button
          rightSection={<IconArrowRight color={'white'} height={18} />}
          onClick={() => onPlanSelect(value)}
        >
          {t('onboarding.next', 'Suivant')}
        </Button>
      </Group>
    </div>
  );
};

export default OnboardingSelectRealEstatePlanForm;
